import request from "@/utils/request";  //导入封装请求的js文件

// 联系方式 QQ
export function getConfigQQ(type) {
    return request({
        url: '/memberApi/config/detail/' + type,
        method: 'get'
    })
}
